import useLocalStorageState from 'use-local-storage-state';
import { Anzeige } from '../entities/tagebuchAnzeige';
import { useMutation } from '@apollo/client';
import {
  UpdateTagebuchEinstellungenMutation,
  UpdateTagebuchEinstellungenMutationVariables,
} from '@/gql/graphql';
import { UPDATE_TAGEBUCH_EINSTELLUNGEN } from './graphql/mutations';
import { useCallback } from 'react';

export function useUpdateTagebuchEinstellungen() {
  const [, setUmsatzplanungAnzeige] = useLocalStorageState<Anzeige>(
    'umsatzplanungAnzeige',
  );

  const [execute, result] = useMutation<
    UpdateTagebuchEinstellungenMutation,
    UpdateTagebuchEinstellungenMutationVariables
  >(UPDATE_TAGEBUCH_EINSTELLUNGEN, {
    refetchQueries: ['getControllingEinstellungenByStandortID'],
  });

  const updateTagebuchEinstellungen = useCallback(
    (variables: UpdateTagebuchEinstellungenMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  function updateUmsatzplanungAnzeige(anzeige: Anzeige) {
    setUmsatzplanungAnzeige(anzeige);
  }

  return { updateUmsatzplanungAnzeige, updateTagebuchEinstellungen, result };
}
